<template>
  <div class="travelagencyhome">
    <div class="wrapper-box">
      <!-- 通知栏1 -->
      <!-- <div class="notice-box">
        <div class="left-block"></div>
        <div class="center-text">导游石梅被纳入重点关注</div>
        <div class="right-box" @click="$router.push('/guide/supervision')">
          <p class="texts">去审核</p>
          <img src="../../assets/travelAgency/ic_righticon.png" alt class="right-icon" />
        </div>
            </div>-->
       <!-- 通知栏1 -->
      <div class="notice-box"
           @click="$router.push('/guide/todoList')"
           v-if="guideTotalCheck > 0">
        <div class="left-block"></div>
        <div class="center-text">有<span class="greencolor">{{guideTotalCheck}}</span>条导游信息待审核
        </div>
        <div class="right-box">
          <p class="texts">去审核</p>
          <img src="../../assets/travelAgency/ic_righticon.png"
               alt
               class="right-icon" />
        </div>
      </div>
      <!-- 通知栏2 -->
      <div class="notice-box1"
           v-if="noticeList.length > 0">
        <div class="left-text">公告</div>
        <van-swipe class="vswipe"
                   :touchable="false"
                   :show-indicators="false"
                   :autoplay="3000"
                   vertical>
          <van-swipe-item class="item"
                          v-for="(item,index) in noticeList"
                          :key="index"
                          @click="noticeTurnTo(item)">
            <div class="swipe-item">
              <div class="center-text greencolor"
                   v-if="level1.indexOf(item.notice_type) !== -1">
                <div class="label">{{item.group_name}}</div>
              </div>
              <div class="center-text bulecolor"
                   v-if="level2.indexOf(item.notice_type) !== -1">
                <div class="label">{{item.group_name}}</div>
              </div>
              <div class="center-text orangecolor"
                   v-if="level3.indexOf(item.notice_type) !== -1">
                <div class="label">{{item.group_name}}</div>
              </div>
              <div class="center-text redcolor"
                   v-if="level4.indexOf(item.notice_type) !== -1">
                <div class="label">{{item.group_name}}</div>
              </div>
              <div class="content-text">{{item.content}}</div>
            </div>
          </van-swipe-item>
        </van-swipe>

        <div class="vline"></div>
      </div>
      <!-- 地区旅行社家书与评分 -->
      <div class="area-box">
        <div class="title-box">
          <div class="areachoose-box">
            <p class="area-text"
               @click="showPicker=true">{{cityName}}</p>
            <img
                 src="../../assets/travelAgency/ic_jiantou_down.png"
                 alt
                 class="down-icon" />
          </div>
          <img @click="$router.push({path:'/guide/search', query:{selfCityId: selfCityId}})"
               src="../../assets/guideSystem/guide_search.png"
               alt
               class="search-icon" />
        </div>
        <div class="content-box">
          <div :class="index == 0 ? 'items-box one-item line_bottom' : (index == 1 ?'items-box line_right' :'items-box')"
               v-for="(lists,index) in areaTravellList"
               :key="index"
               @click="navToList(index)">
            <div class="name-box">
              <p class="names">{{lists.title}}</p>
              <img src="../../assets/travelAgency/ic_righticon.png"
                   alt
                   class="right-icon" />
            </div>
            <div class="numbers">{{lists.numbers}}</div>
            <div class="s-compare">
              较上月
              <span class="c-text"
                    v-if="lists.compare === 'equal'">持平</span>
              <span class="c-text"
                    :class="index > 0 ? 'down': ' up'"
                    v-if="lists.compare === 'add'">+{{lists.price}}↑</span>
              <span class="c-text"
                    :class="index > 0 ? 'down': ' up'"
                    v-if="lists.compare === 'decrease'">-{{lists.price}}↓</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 州市排名 -->
      <div class="cityranking-box">
        <div class="title-box">州市排名</div>
        <div class="content-box">
          <div class="ranking-wrap">
            <tab :tabList="rankingTab"
                 :ref="'rankRef'"
                 :name="'guideRankingTab1'"
                 @onSwitch="myPending"></tab>
          </div>
          <div>
            <rankCharts :rankList="rankList"
                        :selfId="Number(cityId)" />
          </div>
        </div>
      </div>
      <!-- 月度趋势 -->
      <div class="cityranking-box monthlytrend-box">
        <div class="title-box">月度趋势</div>
        <div class="content-box">
          <div class="ranking-wrap">
            <tab :tabList="rankingTab"
                 :ref="'trendRef'"
                 :name="'guideRankingTab2'"
                 @onSwitch="myPendingTrend"></tab>
          </div>
          <!-- <div class="unit-box">单位（名）</div> -->
          <div style="height: 270px;">
            <lineCharts :interval="1"
                        :showYear="true"
                        :data="data"
                        :color="color"
                        :type="trendIndex===2? '黑名单' : trendIndex === 1? '重点关注' : ''"
                        :unit="'名'"
                        :showNum="true"
                        v-if="showLincharts" />
          </div>
        </div>
      </div>
    </div>
    <!-- 城市弹窗 -->
    <van-popup v-model="showPicker"
               position="bottom">
      <van-picker show-toolbar
                  :columns="cityColumns"
                  @cancel="showPicker = false"
                  @confirm="onConfirm"
                  value-key="content"
                  :default-index="cityIndex" />
    </van-popup>
  </div>
</template>
<script>
    import api from '../../service/modules/guide';
    import rankCharts from './components/guideRankCharts';
    import lineCharts from '../guideSystem/components/LineCharts';
    import tab from 'comps/tab';
    import apis from '../../service/modules/index';
    import util from '../../utils/common'
    export default {
        components: {
            rankCharts,
            lineCharts,
            tab
        },

        data () {
            return {
                level1: [
                    'G01',
                    'G02',
                    'G03',
                    'G04',
                    'G05',
                    'G06',
                    'G07',
                    'G10',
                    'G11',
                    'G22',
                    'G24',
                    'G25'
                ],
                level2: ['G17', 'G18', 'G19', 'G20'],
                level3: ['G08', 'G09', 'G12', 'G16', 'G21', 'G23'],
                level4: ['G13', 'G14', 'G15'],
                showPicker: false,
                cityColumns: [{ content: '云南省', value: '' }],
                rankingTab: ['在职总数', '重点关注', '黑名单'],
                areaTravellList: [
                    {
                        id: '1',
                        title: '在职导游(名)',
                        numbers: '',
                        compare: '',
                        price: ''
                    },
                    {
                        id: '2',
                        title: '重点关注导游(名)',
                        numbers: '',
                        compare: '',
                        price: ''
                    },
                    {
                        id: '3',
                        title: '黑名单导游(名)',
                        numbers: '',
                        compare: '',
                        price: ''
                    }
                ],
                rankList: [],
                // 折线图
                data: [],
                color: 'green',
                cityId: '',
                cityName: '',
                tabIndex: 0,
                trendIndex: 0,
                cityIndex: 0,
                noticeList: [],
                userInfo: {
                    OrgInfo: {
                        orgRegionType: ''
                    }
                },
                selfCityId: 0,
                timeOutId: '',
                showLincharts: false,
                guideTotalCheck: 0,
                // guideRole: util.getJsonLocal('guideInfoObj').OrgInfo.orgRegionId
            };
        },

        computed: {},

        watch: {},

        methods: {
            test () { },
            getStateCheck () { // 获取待办数
                apis.todoGuideList({ p: 1, pageSize: 80, status: 0 }).then((res) => {
                    if (res.ret == 0) {
                        if (res.data.list.length > 0) {
                            this.guideTotalCheck = res.data.list.length;
                        }
                    }
                })
            },
            myPending (index) {
                this.tabIndex = index;
                switch (index) {
                case 0:
                    this.getHomeAllList();
                    break;
                case 1:
                    this.getSuperviseList();
                    break;
                case 2:
                    this.getBlackList();
                    break;
                }
            },
            // 公告接口
            getNotice () {
                api.getNotice({
                    // files: [
                    //     { name: 'afdsf', path: 'fdsfa', type: 'img' },
                    //     { name: 'sdfs', path: 'sfddsf', type: 'img' }
                    // ],
                    // remark: 'xxfsafsaf',
                    city: this.selfCityId === '' ? 34 : this.selfCityId
                }).then(res => {
                    if (res.ret === 0) {
                        let data = JSON.parse(res.data);
                        data.map(item => {
                            item.value = JSON.parse(item.value);
                            for (let index in item.value) {
                                item.content = item.content.replace(
                                    index,
                                    item.value[index]
                                );
                            }
                            return item;
                        });
                        console.log('公告数据:', data);
                        this.noticeList = data;
                    }
                });
            },
            noticeTurnTo (items) {
                if (items.url) {
                    window.yyn.invokeJSB(
                        'openWindow', {
                            openUrl: `${this.globalApp.getSystemInfo().host}${items.url}`,
                            isFullScreen: 0,
                            setTitle: '',
                            needLoading: 1
                        },
                        cb => {
                            console.log(cb, 'callback');
                        }
                    );
                    console.log('跳转:', `${this.globalApp.getSystemInfo().host}${items.url}`)
                } else {
                    console.log('没取到url')
                }
            },
            onConfirm (params, index) {
                this.cityId = params.value;
                this.cityName = params.content;
                this.cityIndex = index;
                // this.myPendingTrend(this.trendIndex);
                this.getDashboard();
                this.$refs.trendRef.switchTab(0);
                this.$refs.rankRef.switchTab(0);
                this.showPicker = false;
            },
            myPendingTrend (index) {
                this.trendIndex = index;
                switch (index) {
                case 0:
                    this.getHomeAllTrend();
                    break;
                case 1:
                    this.getSuperviseTrend();
                    break;
                case 2:
                    this.getBalckTrend();
                    break;
                }
            },
            // 得到首页全部列表
            getHomeAllList () {
                api.guideHomeAllList({ city: '' }).then(res => {
                    if (res.ret === 0) {
                        this.rankList = res.data;
                    }
                });
            },
            // 得到所有
            getHomeAllTrend () {
                api.guideAllTrend({ city: this.cityId }).then(res => {
                    if (res.ret === 0) {
                        this.formatTrendList(res.data);
                    }
                });
            },
            // 得到首页数据
            getDashboard () {
                api.guideHomeDashboard({ city: this.cityId }).then(res => {
                  if (res.ret === 0) {
                        let data = res.data;
                      this.areaTravellList.map(item => {
                            let surplus = 0;
                            switch (item.id) {
                            case '1':
                                item.numbers = data.allCount;
                                surplus =
                                    data.allCount - data.previousMonthCount;
                                item.compare =
                                    surplus === 0
                                        ? 'equal'
                                        : surplus < 0
                                            ? 'decrease'
                                            : 'add';
                                item.price = surplus;
                                break;
                            case '2':
                                item.numbers = data.allSuperviseCount;
                                surplus =
                                    data.allSuperviseCount -
                                    data.previousMonthSuperviseCount;
                                item.compare =
                                    surplus === 0
                                        ? 'equal'
                                        : surplus < 0
                                            ? 'decrease'
                                            : 'add';
                                item.price = surplus;
                                break;
                            case '3':
                                item.numbers = data.allBlackCount;
                                surplus =
                                    data.allBlackCount -
                                    data.previousMonthBlackCount;
                                item.compare =
                                    surplus === 0
                                        ? 'equal'
                                        : surplus < 0
                                            ? 'decrease'
                                            : 'add';
                                item.price = surplus;
                                break;
                            }
                            return item;
                        });
                        console.log(this.areaTravellList);
                    }
                });
            },
            // 得到黑名单列表
            getBlackList () {
                api.guideBlackList({ city: '' }).then(res => {
                    if (res.ret === 0) {
                        this.rankList = res.data;
                    }
                });
            },
            // 得到黑名单趋势
            getBalckTrend () {
                api.guideBlackTrend({ city: this.cityId }).then(res => {
                    if (res.ret === 0) {
                        this.formatTrendList(res.data);
                    }
                });
            },
            // 得到重点关注列表
            getSuperviseList () {
                api.guideSuperviseList({ city: '' }).then(res => {
                    if (res.ret === 0) {
                        this.rankList = res.data;
                    }
                });
            },
            // 得到重点关注趋势
            getSuperviseTrend () {
                api.guideSuperviseTrend({ city: this.cityId }).then(res => {
                    if (res.ret === 0) {
                        this.formatTrendList(res.data);
                    }
                });
            },
            formatTrendList (data) {
                data.reverse();
                let arr = [];
                data.forEach(item => {
                    arr.push({
                        xAxis: item.date,
                        num: item.count
                    });
                });
                this.showLincharts = false
                this.data = arr
                this.$nextTick(() => {
                    this.showLincharts = true
                })
            },
            getCityList () {
                api.guideCityList({ city: 34 }).then(res => {
                    if (res.ret === 0) {
                        this.cityColumns = [...this.cityColumns, ...res.data.list];
                        this.cityColumns.forEach(item => {
                            if (Number(item.value) === this.selfCityId) {
                                this.cityName = item.content;
                            }
                        });
                        if (this.cityName === '') {
                            this.cityName = '云南省';
                        }
                    }
                });
            },
            navToList (index) {
                let cityInfo = JSON.stringify({
                    cityId: this.cityId,
                    cityName: this.cityName,
                    cityIndex: this.cityIndex
                });
                localStorage.setItem('cityInfo', cityInfo);
                this.$router.push({
                    path: '/guide/guideList',
                    query: {
                        tabIndex: index,
                        cityId: this.cityId,
                        cityName: encodeURIComponent(this.cityName),
                        cityIndex: this.cityIndex,
                        selfCityId: this.selfCityId
                    }
                });
            }
        },

        mounted () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
            let cityInfo = localStorage.getItem('cityInfo')
                ? JSON.parse(localStorage.getItem('cityInfo'))
                : {};
            this.cityId = cityInfo.cityId || '';
            this.cityName = cityInfo.cityName || '';
            this.cityIndex = cityInfo.cityIndex || 0;
            localStorage.setItem('cityInfo', JSON.stringify({}));
            api.getUser({type: 'GUIDE'}).then(res => {
              this.userInfo = res.data;
                localStorage.setItem('guideInfoObj', JSON.stringify(this.userInfo));
                // this.selfCityId = Number(res.data.OrgInfo.orgRegionId) || '';
                // if (this.userInfo.OrgInfo.orgRegionType !== '1') {
                //     console.log(1111);
                //     this.cityId = Number(res.data.OrgInfo.orgRegionId) || '';
                //     this.cityId = this.cityId === 34 ? '' : this.cityId;
                // }
                this.myPendingTrend(0)
                this.getDashboard();
                this.getCityList();
                localStorage.guideNotice = setInterval(() => {
                    this.getNotice();
                }, 60000);
                this.getNotice();
            });
            this.getStateCheck();
        },
        created () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
        },
        beforeDestroy () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
        },
        destroyed () {
            clearInterval(localStorage.guideNotice)
            clearInterval(localStorage.travelNotice)
        }
    };
</script>
<style scoped lang="less">
.travelagencyhome {
  background: #fbfbfb;
  padding-bottom: 24px;
  .backnav-box {
    height: 44px;
    background: rgba(54, 179, 116, 1);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .back-icon {
      position: absolute;
      width: 10px;
      height: 16px;
      top: 14px;
      left: 20px;
    }
    .backnav-text {
      font-size: 16px;

      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
  }
  .wrapper-box {
    box-sizing: border-box;
    padding: 16px 12px 0 12px;
    .notice-box {
      height: 48px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-bottom: 12px;

      .left-block {
        width: 4px;
        height: 48px;
        background: rgba(54, 179, 116, 1);
        margin-right: 12px;
      }
      .center-text {
        font-size: 10px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 18px;
        flex: 1;
        &.greencolor {
          color: #36b374;
          margin: 0 4px;
        }
      }
      .right-box {
        width: 64px;
        display: flex;
        align-items: center;
        margin-right: 16px;

        .texts {
          font-size: 16px;

          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 16px;
          margin-right: 4px;
        }
        .right-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
    .notice-box {
      height: 48px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-bottom: 12px;

      .left-block {
        width: 4px;
        height: 48px;
        background: rgba(54, 179, 116, 1);
        margin-right: 12px;
      }
      .center-text {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
        flex: 1;

        .greencolor {
          color: #36b374;
          margin: 0 4px;
        }
      }
      .right-box {
        display: flex;
        align-items: center;
        margin-right: 16px;

        .texts {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 16px;
          margin-right: 4px;
        }
        .right-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
    .notice-box1 {
      .vline {
        position: absolute;
        width: 1px;
        background: #eeeeee;
        height: 30px;
        left: 56px;
        top: 0;
      }
      position: relative;
      display: flex;
      align-items: center;
      height: 30px;
      background: #f5f5f5;
      border-radius: 3px;
      box-sizing: border-box;
      padding-left: 16px;
      margin-bottom: 26px;

      .left-text {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 17px;
        margin-right: 33px;
        white-space: nowrap;
      }
      .vswipe {
        width: 100%;
        height: 30px;

        .item {
          display: flex;
          align-items: center;
          height: 30px;
          width: 100%;
          .swipe-item {
            width: 200%;
            transform: scale(0.5);
            transform-origin: left center;
            display: flex;
            align-items: center;
            .center-text {
              // min-width: 62px;
              padding: 0 16px;
              height: 36px;
              border-radius: 1px;
              font-size: 20px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              // line-height: 36px;
              text-align: center;
              margin-right: 16px;
              white-space: nowrap;
              display: table;
              .label {
                height: 36px;
                line-height: 36px;
                display: table-cell;
                vertical-align: middle;
              }
              &.greencolor {
                background: #36b374;
                // margin: 0 4px;
              }
              &.bulecolor {
                background: #2283e6;
              }
              &.orangecolor {
                background: #ff8c19;
              }
              &.redcolor {
                background: #ff4d4d;
              }
            }
            .content-text {
              font-size: 24px;

              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 34px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
    .area-box {
      .title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 32px;
        font-weight: bold;
        box-sizing: border-box;
        padding-bottom: 12px;

        .areachoose-box {
          display: flex;
          align-items: center;

          .area-text {
            font-size: 20px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            margin-right: 4px;
          }
          .down-icon {
            width: 6px;
            height: 4px;
          }
        }
        .search-icon {
          width: 15px;
          object-fit: cover;
          // height: 14px;
        }
      }
      .content-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        display: flex;
        flex-wrap: wrap;

        .items-box {
          height: 126px;
          width: 49.5%;
          display: inline-block;
          box-sizing: border-box;
          padding-top: 22px;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: hidden;

          // &:nth-of-type(2) {
          //     border-right: 1px solid rgba(238, 238, 238, 0.8);
          // }

          .name-box {
            display: flex;
            align-items: center;
            height: 14px;
            .names {
              font-size: 12px;

              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              margin-right: 4px;
              line-height: 12px;
            }
            .right-icon {
              width: 12px;
              height: 12px;
              // margin-top: 2px;
            }
          }
          .numbers {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            -webkit-font-smoothing: antialiased;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            line-height: 48px;
            height: 48px;
          }

          .s-compare {
            margin-top: 8px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #999999;

            .c-text {
              color: #118bf5;

              &.up {
                color: #36b374;
              }

              &.down {
                color: #ff4d4d;
              }
            }
          }
        }
        .one-item {
          width: 100%;
          // border-bottom: 1px solid rgba(238, 238, 238, 0.8);
        }
      }
    }
    .cityranking-box {
      box-sizing: border-box;
      padding-top: 12px;

      .title-box {
        font-size: 20px;

        font-family: PingFang SC, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
      }
      .content-box {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        overflow: hidden;
        position: relative;
        .data-card-tab {
          margin-top: 16px !important;
          margin-bottom: 18px !important;
          margin-left: 16px;
        }
        .unit-box {
          position: absolute;
          top: 56px;
          left: 16px;
          font-size: 10px;
          color: rgba(153, 153, 153, 1);
          font-weight: 400;
        }
      }
    }
  }
}
</style>
